export default __webpack_public_path__ + "static/media/Голосования за развитие Москвы.98af4bfa.jpg";